import { clearFeaturesCache } from '@/config/menu.config';
import i18n from '@/i18n';
import { getLogger } from '@/lib/logger/logger';
import { REGION_STORAGE_KEYS } from '@/shared/constants/region';

const logger = getLogger('changeLanguage');

/**
 * Core language change function (non-hook).
 * Handles: cache clear, i18n change, HTML lang, localStorage.
 * Does NOT handle URL updates (React Router dependent → use useLanguage hook).
 */
export const changeLanguageCore = async (newLang: 'ko' | 'en' | 'ja'): Promise<void> => {
  if (i18n.language === newLang) {
    logger.debug('[changeLanguage] Already set to:', newLang);
    return;
  }

  logger.info('[changeLanguage] Changing:', { from: i18n.language, to: newLang });

  clearFeaturesCache();
  await i18n.changeLanguage(newLang);
  document.documentElement.lang = newLang;
  localStorage.setItem(REGION_STORAGE_KEYS.I18N_LNG, newLang);
};
